import type { Campaign, Collab } from '@foodfluence/shared';
import { isBrandManagedCampaignType, isRetailCampaignType, isShippingCampaignType } from 'utils/collabUtils';
import { productSelectionDestination } from './productSelection';
import { MAX_COUNTERS } from './counterUtils';

/** Accept button copy naming the step the accept leads into (same branching as the accept handler). */
export const acceptLabelFor = (campaign: Campaign): string => {
  if (productSelectionDestination(campaign)) return 'Accept & pick products';
  if (isShippingCampaignType(campaign.campaignType)) return 'Accept & add address';
  if (isRetailCampaignType(campaign.campaignType)) return 'Accept & pick store';
  if (isBrandManagedCampaignType(campaign.campaignType)) return 'Accept offer';
  return 'Accept & book visit';
};

/** "Expires in 1d 6h" / "Expires in 5h 12m" / "Expires in 12m". */
export const formatExpiresIn = (expiry: Date, now: number = Date.now()): string => {
  const mins = Math.max(0, Math.floor((expiry.getTime() - now) / 60000));
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  return `Expires in ${d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`}`;
};

/**
 * Which counter this is. A pending invite starts a new round; on a collab already countered by the
 * creator the form edits the latest one, which doesn't use a counter.
 */
export const counterRound = (collab: Collab): { number: number; isEdit: boolean; remainingAfter: number } => {
  const used = collab.counters?.length ?? 0;
  const isEdit = collab.status !== 'pendingInfluencerApproval';
  const number = isEdit ? Math.max(used, 1) : used + 1;
  return { number, isEdit, remainingAfter: Math.max(0, MAX_COUNTERS - number) };
};
